import { render, staticRenderFns } from "./YCheckbox.vue?vue&type=template&id=0e824111&lang=pug&"
import script from "./YCheckbox.vue?vue&type=script&lang=js&"
export * from "./YCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports